import SearchBlock from './searchBlock'

export default SearchBlock
